var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypalPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 4.66665C12.6667 4.79998 12.6667 4.86665 12.6667 4.99998C12.6 5.99998 12.1334 6.86665 11.5334 7.46665C10.8 8.19998 9.80004 8.66665 8.66671 8.66665H6.60004C6.26671 8.66665 6.00004 8.93331 5.93337 9.26665L5.40004 12.8C5.33337 13.0666 5.20004 13.2666 4.93337 13.3333C4.86671 13.3333 4.80004 13.3333 4.73337 13.3333H3.46671C3.06671 13.3333 2.73337 13 2.80004 12.5333L4.40004 2.99998C4.53337 2.06665 5.40004 1.33331 6.33337 1.33331H9.33338C11.2 1.33331 12.6667 2.79998 12.6667 4.66665Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.33333C14 8.26667 13.6 9.06667 13 9.66667C12.4 10.2667 11.6 10.6667 10.6667 10.6667H9.26671C8.93337 10.6667 8.66671 10.8667 8.60004 11.2L8.13337 14.0667C8.06671 14.4 7.80004 14.6 7.46671 14.6H5.46671C5.06671 14.6 4.73337 14.2 4.80004 13.8L4.93337 13.3333C5.20004 13.2667 5.40004 13.0667 5.40004 12.8L5.93337 9.26667C6.00004 8.93333 6.26671 8.66667 6.60004 8.66667H8.66671C9.80004 8.66667 10.8 8.2 11.4667 7.46667C12.1334 6.8 12.5334 5.93333 12.6 5C13.4667 5.46667 14 6.33333 14 7.33333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalPaymentIcon);
export default __webpack_public_path__ + "static/media/paypal-payment-icon.8ecb94a5a16b38767a63d0abfc4d6b58.svg";
export { ForwardRef as ReactComponent };